import { render, staticRenderFns } from "./CloudMining.vue?vue&type=template&id=3f3ee986&scoped=true"
import script from "./CloudMining.vue?vue&type=script&lang=js"
export * from "./CloudMining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ee986",
  null
  
)

export default component.exports